import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const record5Api = {
    //查詢名片和資訊記錄
    "queryMemberWorkAndRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record5/queryMemberWorkAndRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                recordno: 1,
                // updatedid: null    //名片id 已棄用
            }
        }
    },
    //刪除資訊記錄
    "deleteRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record5/deleteRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
            }
        }
    },
    //修改資訊記錄
    "editRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record5/editRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo1: null,
                addinfo2: null,
                addinfo4: null,
                addremark1: null,
                companycode: null,
                fileformatList: null,
                id: null,
                imgs: null,
                recordno: null,
                updatedid: null
            }
        }
    },
    //添加資訊記錄
    "insertRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record5/insertRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo1: null,
                addinfo2: null,
                addinfo4: null,
                addremark1: null,
                companycode: null,
                imgs: null,
                recordno: 1
            // updatedid: null  //名片id 已棄用
            }
        }
    },
    //查詢資訊年份列表
    "queryYears": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record5/queryYears`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,
                recordno: 1
            }
        }
    },
    //分頁查詢公司資訊
    "queryMemberWorkAndRecordByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record5/queryMemberWorkAndRecordByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo2: null,
                addinfo3: null,
                companycode: null,
                pageNum: 1,
                pageSize: 5,
                recordno: 1,
                updatedid: null
            }
        }
    }
}

export default record5Api